import { useState } from "react";
import { useTranslate } from "@refinedev/core";
import { EnvelopeIcon, SettingsTileCard } from "@fawkes/ui";

import { CommunicatieScreen } from "../../CommunicatieScreen";
import type { TileComponentProps } from "./types";

// Communicatie & contracten — templates/contracts/e-mail. Present in both contexts; the vestiging
// context swaps "Contracten/Email berichten" for "Mail lay-out". The migrated detail screen
// (CommunicatieScreen) opens over the dashboard in a full-screen overlay — real CRUD over the
// docasoft store via /api/communicatie/* (settings-communicatie).
export const COMMUNICATION_TILE_KEY = "communication";

const ORG_ITEM_KEYS = [
  "instellingen.item.afdrukken",
  "instellingen.item.contracten",
  "instellingen.item.emailBerichten",
];
const BRANCH_ITEM_KEYS = ["instellingen.item.afdrukken", "instellingen.item.mailLayout"];

export function CommunicationTile({ context }: TileComponentProps) {
  const t = useTranslate();
  const [open, setOpen] = useState(false);
  const itemKeys = context.type === "branch" ? BRANCH_ITEM_KEYS : ORG_ITEM_KEYS;

  if (open) {
    return (
      <div className="settings-communication-overlay">
        <CommunicatieScreen context={context.type} onBack={() => setOpen(false)} />
      </div>
    );
  }

  return (
    <SettingsTileCard
      tileKey={COMMUNICATION_TILE_KEY}
      icon={<EnvelopeIcon className="settings-tile-icon" width={16} height={16} />}
      title={t("instellingen.tile.communication.title")}
      description={t("instellingen.tile.communication.desc")}
      items={itemKeys.map((k) => t(k))}
      openLabel={t("instellingen.cta.open")}
      onOpen={() => setOpen(true)}
    />
  );
}
